export default __webpack_public_path__ + "static/media/bn1.524a1406.png";